// extracted by mini-css-extract-plugin
module.exports = {"tableMenu":"ReadingBookComponent_tableMenu__1e1C6"};